class BundleRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.style.setProperty('display', 'flex');

    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.removeBundle();
    });
  }

  async removeBundle() {
    const bundleId = this.dataset.bundleId;

    if (!bundleId) {
      console.error('No bundle ID provided');
      return;
    }

    this.enableLoading();

    try {
      const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (!cartResponse.ok) {
        throw new Error('Failed to fetch cart');
      }

      const cartData = await cartResponse.json();

      const bundleItemKeys = [];
      cartData.items.forEach(item => {
        if (item.properties?._bundle_id && item.properties._bundle_id == bundleId) {
          bundleItemKeys.push(item.key);
        }
      });

      if (bundleItemKeys.length === 0) {
        console.warn('No bundle items found with ID:', bundleId);
        this.disableLoading();
        return;
      }

      const updates = {};
      bundleItemKeys.forEach(key => {
        updates[key] = 0;
      });

      const updateResponse = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ updates })
      });

      if (!updateResponse.ok) {
        throw new Error('Failed to update cart');
      }

      const updatedCart = await updateResponse.json();

      document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: { cartData: updatedCart }
        })
      );

      document.documentElement.dispatchEvent(
        new CustomEvent('cart:updated', {
          bubbles: true,
          detail: { cartData: updatedCart }
        })
      );

    } catch (error) {
      console.error('Error removing bundle:', error);
      const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
      if (errors) {
        errors.textContent = 'Failed to remove bundle. Please try again.';
      }
    } finally {
      this.disableLoading();
    }
  }

  enableLoading() {
    this.setAttribute('disabled', '');
    const button = this.querySelector('button') || this.querySelector('a');
    if (button) {
      button.setAttribute('disabled', '');
      button.style.opacity = '0.5';
      button.style.pointerEvents = 'none';
    }
  }

  disableLoading() {
    this.removeAttribute('disabled');
    const button = this.querySelector('button') || this.querySelector('a');
    if (button) {
      button.removeAttribute('disabled');
      button.style.opacity = '';
      button.style.pointerEvents = '';
    }
  }
}

customElements.define('bundle-remove-button', BundleRemoveButton);

